const DARK = '#181c32';
const LIGHT = '#ffffff';

const channel = (value: number) => {
	const v = value / 255;
	return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
};

const luminance = (hex: string): number | null => {
	const clean = hex.trim().replace('#', '');
	const full =
		clean.length === 3
			? clean
					.split('')
					.map((c) => c + c)
					.join('')
			: clean;
	if (!/^[0-9a-fA-F]{6}$/.test(full)) return null;

	const r = parseInt(full.slice(0, 2), 16);
	const g = parseInt(full.slice(2, 4), 16);
	const b = parseInt(full.slice(4, 6), 16);
	return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
};

const contrast = (a: number, b: number) =>
	(Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);

/**
 * Cor de texto (grafite ou branco) que mais contrasta com um fundo.
 *
 * Para texto sobre a cor da plataforma, que é livre. Decide pelo contraste
 * real (WCAG), não por um corte de "claro/escuro": um roxo como #7c3aed tem
 * brilho médio e um corte fixo o trata como claro — texto grafite sobre ele
 * dá 2,9 de contraste, branco dá 5,7.
 */
export const readableTextColor = (background?: string | null): string => {
	const bg = background ? luminance(background) : null;
	if (bg === null) return DARK;

	const withDark = contrast(bg, luminance(DARK) as number);
	const withLight = contrast(bg, 1);
	return withLight >= withDark ? LIGHT : DARK;
};
